/// \file userAgreements.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const UserAgreementsList = lazy(() => import('../views/user-agreements/list/view'));

async function UserAgreementsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/user-agreements/list/loader')).default;
  return actualLoader(args);
}

export async function UserAgreementsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/user-agreements/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="user-agreements"
    handle={{
      text:"USER AGREEMENTS"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <UserAgreementsList />
        </Suspense>
      }
      loader={UserAgreementsDataLoader}
      action={UserAgreementsAction}
      />
  </Route>
);

export default routes;